// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Report } from './report';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ReportLayout extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  reportLayoutId!: number;
  description!: string;
  hasSubReports!: boolean;
  layout?: any;
  parentReportLayoutId?: number;
  inverseParentReportLayout!: ReportLayout[];
  parentReportLayout!: ReportLayout;
  reports!: Report[];
}

